import './App.css';
import Sphere from './Sphere';

function App() {
  return (
    <div className="App">
      <Sphere />
    </div>
  );
}

export default App;
